import { useLocation } from '@gatsbyjs/reach-router'
import { Grid } from '@material-ui/core'
import classnames from 'classnames'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { HotJarNPSSurvey } from '../../components/buy/summary/HotJarNPSSurvey'
import useStyles from './styles/leftHalfLayout'

export interface LeftHalfLayoutProps {
  className?: string
}

const StyledGrid = styled(Grid)`
  @media (min-width: 960px) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-radius: 0 0 4px 4px;
  }
`

const LeftHalfLayout: React.FC<LeftHalfLayoutProps> = ({ children, className }) => {
  const classes = useStyles()
  const location = useLocation()
  const getCurrentPath = useCallback(() => `${location.pathname}${location.search}`, [location])
  const isConfirmationPage = getCurrentPath().includes('/checkout/confirmation')

  return (
    <Grid
      alignItems="flex-start"
      className={classnames(classes.leftHalfLayout, className)}
      container
      item
      justify="center"
      md={7}
      sm={10}
      xs={12}
    >
      {isConfirmationPage ? (
        <StyledGrid alignItems="center" container item justify="center" sm={10} xs={12}>
          {children}
        </StyledGrid>
      ) : (
        <Grid alignItems="center" container item justify="center" sm={10} xs={12}>
          {children}
        </Grid>
      )}
      {isConfirmationPage && (
        <Grid
          alignItems="center"
          container
          item
          justify="center"
          sm={10}
          xs={12}
          style={{ border: 'none' }}
        >
          <HotJarNPSSurvey />
        </Grid>
      )}
    </Grid>
  )
}

const StyledLeftHalfLayout = styled(LeftHalfLayout)`
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 20px;

  @media (min-width: 600px) {
    padding-left: 0;
    padding-right: 0;
  }
`

export default StyledLeftHalfLayout
